import { computed, action } from 'mobx'
import autobind from 'autobind-decorator'

@autobind
export default class WizardCompletedState {
  stepId = 'WizardCompleted'
  title = ' '
  trackingId = 'Onboarding - Payment Success'

  constructor ({ wizard }) {
    this.wizard = wizard
    this.hideBackButton = true
  }

  @computed get currentUser () {
    return this.wizard.rootStore.authStore.user
  }

  @computed get showPersonalFilingTip () {
    const legend = this.wizard.getStep('ProjectType').legend
    if (!legend) {
      return false
    }

    return legend.id === 'BUSINESS_TAX_RETURN'
  }

  @computed get job () {
    return this.wizard.job
  }

  @action showEmailDialog () {
    this.wizard.rootStore.changeEmailDialogStore.show()
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/WizardCompleted/WizardCompletedState.js